import Actions from '../actions/actions';
import suppressionListsCRUDActions from '../actions/SuppressionListsCRUDActions';
import {
  SuppressionList,
  SuppressionListModel,
} from '../model/SuppressionListModel';
import { setBusy, setUnBusy } from './common/commonReducers';

type ActionType = {
  type: string;
  entities: SuppressionList[];
  entity: SuppressionList;
};

const initialState: SuppressionListModel = {
  busy: false,
  entities: [],
};

export const suppressionLists = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case suppressionListsCRUDActions.busyAction:
      return setBusy(state);

    case suppressionListsCRUDActions.retrievedAllAction: {
      return {
        ...state,
        entities: action.entities,
        busy: false,
      };
    }
    case suppressionListsCRUDActions.retrievedAction: {
      const suppression = action.entity;
      const { entities } = state;
      const index = entities.findIndex(p => p.id === suppression.id);
      const newSuppressions = Object.assign([], entities.slice(), {
        [index === -1 ? entities.length : index]: suppression,
      });
      return {
        ...state,
        entities: newSuppressions,
        busy: false,
      };
    }
    case suppressionListsCRUDActions.deleteLocalAction: {
      const suppression = action.entity;
      const { entities } = state;
      const newSuppressions = entities.filter(p => p.id !== suppression.id);
      return {
        ...state,
        entities: newSuppressions,
        busy: false,
      };
    }
    case suppressionListsCRUDActions.resetStore: {
      return initialState;
    }
    case suppressionListsCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
